import * as cls from './class-toggles';

let scrollPosition = window.scrollY;
const htmlEl = document.querySelector('html');
const navToggle = document.querySelector('.nav-toggle');
const navMenu = document.querySelector('.nav-menu');
const navMenuItems = document.querySelectorAll('.nav-menuItem-link');
const headerHome = document.querySelector('.nav');
const headerHeight = headerHome.offsetHeight;
const addHeaderClassOnScroll = () => headerHome.classList.add('is-active');
const removeHeaderClassOnScroll = () => headerHome.classList.remove('is-active');

export default () => {
  navToggle.onclick = function () {
    cls.toggleClass(headerHome, 'open');
    cls.toggleClass(navMenu, 'open');
    cls.toggleClass(navToggle, 'open');
    cls.toggleClass(htmlEl, 'no-overflow');
  };
  navMenuItems.forEach((navItem) => {
    navItem.onclick = function () {
      cls.removeClass(headerHome, 'open');
      cls.removeClass(navMenu, 'open');
      cls.removeClass(navToggle, 'open');
      cls.removeClass(htmlEl, 'no-overflow');
    };
  });
  window.addEventListener('scroll', function () {
    scrollPosition = window.scrollY;

    if (scrollPosition >= headerHeight) {
      addHeaderClassOnScroll();
    } else {
      removeHeaderClassOnScroll();
    }
  });
};
